import { ChangeEvent, useMemo } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { AppFormSelect } from 'client/ui-building-blocks'
import { useGetQuestionCategories } from 'client/api'

type Props = {
  isLoading?: boolean
  isDisabled?: boolean
  includeAnyCategory?: boolean
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void
}

const QuestionCategorySelect = (props: Props) => {
  const { t, i18n } = useTranslation()

  const {
    control,
    formState: { errors },
    setError,
    resetField,
  } = useFormContext()

  const { isFetching: isFetchingCategories, data: categories } = useGetQuestionCategories(
    {
      onError: err => {
        if (err?.msg) {
          setError('category', {
            message: t(`apiMsgs.${err.msg.code}`),
          })
        }
      },
    }
  )

  const CATEGORY_OPTIONS = useMemo(() => {
    if (!categories) {
      return []
    }
    return props.includeAnyCategory
      ? [
          { key: 'any', value: 'any', text: 'Any' },
          ...categories[i18n.language.toLowerCase()],
        ]
      : categories[i18n.language.toLowerCase()]
  }, [categories])

  return (
    <Controller
      control={control}
      name="category"
      rules={{
        required: t('common.validation.required'),
      }}
      render={({ field: { value, onChange } }) => {
        return (
          <AppFormSelect
            value={value}
            options={CATEGORY_OPTIONS || []}
            label={t('forms.questionCategory.label')}
            placeholder={t('forms.questionCategory.placeholder')}
            loading={props.isLoading || isFetchingCategories}
            disabled={props.isDisabled}
            onChange={e => {
              resetField('subject')
              props.onChange?.(e)
              onChange(e)
            }}
            error={String(errors.category?.message || '')}
          />
        )
      }}
    />
  )
}

export default QuestionCategorySelect
